import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

const SESSION_KEY = "skilll_analytics_session_id";
const ANON_KEY = "skilll_analytics_anon_id";

function makeId(prefix) {
  return `${prefix}_${Math.random().toString(36).slice(2)}_${Date.now()}`;
}

function getStoredId(key, prefix) {
  if (typeof window === "undefined") return makeId(prefix);

  const existing = window.localStorage.getItem(key);
  if (existing) return existing;

  const next = makeId(prefix);
  window.localStorage.setItem(key, next);
  return next;
}

export function getAnalyticsSessionId() {
  return getStoredId(SESSION_KEY, "session");
}

export function getAnalyticsAnonymousId() {
  return getStoredId(ANON_KEY, "anon");
}

export async function trackProductEvent(eventName, properties = {}, options = {}) {
  if (!eventName) return;

  try {
    const path =
      options.path ||
      (typeof window !== "undefined"
        ? `${window.location.pathname}${window.location.search || ""}`
        : "");

    await addDoc(collection(db, "product_events"), {
      event: eventName,
      uid: options.user?.uid || null,
      userEmail: options.user?.email || null,
      sessionId: getAnalyticsSessionId(),
      anonymousId: getAnalyticsAnonymousId(),
      path,
      referrer:
        options.referrer ??
        (typeof document !== "undefined" ? document.referrer || "" : ""),
      source: options.source || "web_app",
      properties,
      userAgent:
        typeof navigator !== "undefined" ? navigator.userAgent || "" : "",
      createdAt: serverTimestamp(),
      clientCreatedAt: new Date().toISOString(),
    });
  } catch (error) {
    console.warn("Analytics tracking failed:", error?.message || error);
  }
}
